import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react'
import { useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal'
import Badge from 'react-bootstrap/Badge';
import { PreOrderFetchAPI } from '../../api/Paymentpost/PreOrder';
import { DeletedTempOrdersFetchAPI } from '../../api/DeletedTemporalOrders';
import ModalDivisionPreOrder from '../DivisionPreOrder/ModalDivisionPreOrder';
import ModalJustification from './ModalJustification';
import ModalSendLinkPayment from '../Modals/Pays/ModalSendLinkPayment';
import { Tabs, Tab, Row, Col, Nav } from 'react-bootstrap';
import Swal from "sweetalert2";
import imgPreOrder from './img/preOrder.png'
import ErrorAlert from '../Alerts/ErrorAlert';
import LoadingAlert from '../Alerts/LoadingAlert';
import moment from 'moment-timezone';
import { GiPlayerTime } from 'react-icons/gi';
import Empty from '../utils/Empty';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import DocPdf from '../Pdf/DocPdf';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { OrdersFetchAPI } from '../../api/Orders';
import Modalblind from './Modalbind';
import { ClientsFetchAPI } from '../../api/Clients';
import InvoicePDF from '../Pdf/documents/InvoicePDF';
import { RenderIf } from '../utils/RenderIf';
import { checkUserPermission } from '../utils/CheckUserPermitions';
import OrderPreview from './OrderPreview';
import PrecuentaModal from '../PendingOrders/PrecuentaModal';
import AlertSmall from '../Alerts/AlertSmall';
import { showApiError } from '../../utils/ApiError';
import { normalizeRecoveredPreOrderItems } from '../../utils/PreOrderPaymentPrint';

import ModalQuoteDetails from './ModalQuoteDetails';

function ModalPendingOrders({
   autoOpen,
   autoSelectOrderId,
   actvLite, actvPlus, preOrderInvoice, setPreOrderInvoice, setCheckDeliveryOrder,
   setProductChecked, setCombosChecked, setPageLoader, setEventHandler, shoppingCart, shoppingCartCombos,
   setDv, setName, setRuc, setDataResponse, setOptionalData, setShoppingCart, setShoppingCartCombos,
   setInvoiceSubtotal, setInvoiceTotal, setInvoiceTotalDiscount, setInvoiceTotalItbms, setDataPreOrder,
   setTableInfo, setTaxesArrayAll, setdataDiscountApply, setDataReferenceOrderMicros, codeParthner,
   selectPreOrder, setSelectPreOrder,
   domain, setdataClientSelected, setAddresDescriptionClientFiscal, setAditional_data, setEventSelect, orderNumberNow, dataPreOrder, setResetData, getOrderNumber }) {
   let title_modal = "Precuentas"
   let logo = localStorage.getItem('businessLogo');
   const inputRefs = useRef([]);
   const [selectedInputs, setSelectedInputs] = useState([]);
   const [orderForSendLink, setOrderForSendLink] = useState(null);
   const [show, setShow] = useState(false);
   const [showModalBind, setShowModalBind] = useState(false);
   const [preOrders, setPreOrders] = useState([]);
   const [preOrdersPendingDelete, setPreOrdersPendingDelete] = useState([]);
   const preOrdersPendingDeleteRef = useRef([]);
   const [quotes, setQuotes] = useState([]);
   // const [selectPreOrder, setSelectPreOrder] = useState({ order: "" })
   const [justification, setJustification] = useState("")
   const [bind, setBind] = useState(false)
   const [dataPreOrderBind, setDataPreOrderBind] = useState([])
   const [shopingcartBind, setShopingcartBind] = useState([])
   const [shopingcartComboBind, setShopingcartComboBind] = useState([])
   const [sendLinkPayment, setSendLinkPayment] = useState(false)
   const [search, setSearch] = useState("");
   const [branchOfficeData, setBranchofficeData] = useState({
      "ruc": "",
      "dv": "",
      "name": "",
      "ruc_type": "",
      "direction": "",
      "dgi_name": "",
   });
   const [clientDataByTemporalOrder, setClientDataByTemporalOrder] = useState(null);
   const [domainBusiness, setDomainBusiness] = useState(() => {
      const storedDomain = localStorage.getItem('business');
      return storedDomain ? JSON.parse(storedDomain).domain : '';
   });

   const didAutoOpenRef = useRef(false);
   const didAutoSelectRef = useRef(false);
   //Auto open pending orders
   const location = useLocation();
   let user = localStorage.getItem('user');
   //We validate if the user is logged in
   if (user === null || user === undefined || user === '' || user === 'null') {
      user = {
         name: 'No registrado',
         img: 'https://www.pngitem.com/pimgs/m/30-307416_profile-icon-png-image-free-download-searchpng-employee.png',
         permissions: []
      }
   } else {
      user = JSON.parse(localStorage.getItem('user'))
   }

   const selectedPreOrderRef = useRef(null);
   const normalizePreOrderCode = (code) => String(code ?? "");

   // minDate: 3 meses atrás a las 00:00:00, maxDate: hoy a las 23:59:59
   const [minDate, setMinDate] = useState(
      moment().tz('America/Bogota').subtract(3, 'months').startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ')
   );
   const [maxDate, setMaxDate] = useState(
      moment().tz('America/Bogota').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ')
   );

   const [showModal, setShowModalNew] = useState(false);
   let machine_token = localStorage.getItem('x-access-machine-token');


   //action generated 
   const getAll = async (quote) => {

      let token = localStorage.getItem('x-access-machine-token');
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      let business = JSON.parse(localStorage.getItem('business'))

      let business_code = business.code
      let branch_code = branchoffice.code

      if (codeParthner != 0) {
         business_code = codeParthner.business_code
         branch_code = codeParthner.branchoffice_code
      }

      if (quote == true) {
         await getOrderQuote()
      } else {
         await getPreOrder(business_code, branch_code, token);
      }

      setShowModalNew(true)
   }


   //get client by id 
   const getClientById = async (client_id) => {
      try {
         const response = await ClientsFetchAPI.getClientsById(client_id, machine_token);
         setClientDataByTemporalOrder(response.data.data);

      } catch (err) {
         console.log(err);
      }
   }

   //get pre orders
   const getPreOrder = async (business_code, branch_code, token) => {
      LoadingAlert("Cargando Precuentas...", "Espere un momento por favor.")
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      const params = new URLSearchParams(window.location.search);
      const preOrder = (params.get('pre_order') || '').toLowerCase() === 'true';
      const orderId = params.get('order_id');
      try {
         const response = await PreOrderFetchAPI.getPreOrder(business_code, branch_code, token)
         AlertSmall("Precuentas cargadas", "success")
         setSelectPreOrder({ order: "" });
         console.log("las precuentas son", response.data.pre_orders);

         // Ordenar por fecha de creación (más reciente primero)
         let dataPreOrder = response.data.pre_orders.slice().sort((a, b) => {
            return new Date(b.createdAt) - new Date(a.createdAt);
         });
         let newArrayPreorder = [];
         dataPreOrder.forEach(order => {
            if (branchoffice.code == order.branchoffice.code) {
               newArrayPreorder.push(order);
            }
         });
         //We verify if the logged user has just the waiter rol, if it is like that we filter the pre orders to show just the pre orders created by the logged user
         let user = JSON.parse(localStorage.getItem('user'))
         if (user.role.length == 1 && user.role[0].name.toLowerCase() == "mesero") {
            let newArrayPreorderWaiter = []
            newArrayPreorder.forEach(order => {
               if (order.waiter !== undefined) {
                  if (order.waiter.id == user.id) {
                     newArrayPreorderWaiter.push(order)
                  }
               }
            });
            newArrayPreorder = newArrayPreorderWaiter
         }
         if (preOrdersPendingDeleteRef.current.length > 0) {
            newArrayPreorder = newArrayPreorder.filter(order => !preOrdersPendingDeleteRef.current.includes(normalizePreOrderCode(order.code)));
         }
         setPreOrders(newArrayPreorder)
         // English comment: use the freshly built array to avoid stale state
         if (autoOpen && preOrder && orderId) {
            const idx = newArrayPreorder.findIndex(o => o._id === orderId);
            if (idx !== -1) {
               const selected = newArrayPreorder[idx];

               selectedPreOrderRef.current = selected; // Keep the latest selection immediately
               setSelectPreOrder({ order: selected });
               // Visually check the radio
               setTimeout(() => {
                  if (inputRefs.current[idx]) {
                     inputRefs.current[idx].checked = true;
                  }

                  questionConfirmation(selected)
               }, 0);

               if (newArrayPreorder[idx].client_id && newArrayPreorder[idx].client_id !== 0) {
                  getClientById(newArrayPreorder[idx].client_id);
               }
            }
         }
      } catch (err) {
         showApiError(err, {
            title: "No se pudieron cargar las precuentas",
            message: "No hay precuentas disponibles o el servidor no respondio.",
            context: `business=${business_code} branch=${branch_code}`,
         }, ErrorAlert);
         setPreOrders([])
      }
   }

   const hidePreOrderPendingDelete = (code, createdPreOrders = []) => {
      if (!code) return;
      const normalizedCode = normalizePreOrderCode(code);
      const nextSelectedOrder = createdPreOrders.find((createdOrder) => normalizePreOrderCode(createdOrder?.code) !== normalizedCode) || null;

      if (!preOrdersPendingDeleteRef.current.includes(normalizedCode)) {
         preOrdersPendingDeleteRef.current = [...preOrdersPendingDeleteRef.current, normalizedCode];
      }

      setPreOrdersPendingDelete(preOrdersPendingDeleteRef.current);
      setPreOrders((current) => {
         const visibleOrders = current.filter(order => normalizePreOrderCode(order.code) !== normalizedCode);
         const newOrders = createdPreOrders.filter((createdOrder) => {
            const createdCode = normalizePreOrderCode(createdOrder?.code);
            return createdCode && !preOrdersPendingDeleteRef.current.includes(createdCode) && !visibleOrders.some(order => normalizePreOrderCode(order.code) === createdCode);
         });
         return [...newOrders, ...visibleOrders];
      });

      if (nextSelectedOrder) {
         selectedPreOrderRef.current = nextSelectedOrder;
         setSelectPreOrder(nextSelectedOrder);
         setHasUserSelected(true);
         setExpandedOrderId(nextSelectedOrder.code);
      } else {
         setSelectPreOrder({ order: "" });
         selectedPreOrderRef.current = null;
         setHasUserSelected(false);
         setExpandedOrderId(null);
      }
   }

   const getTemporalOrderById = async (order, deleted) => {
      try {
         let token = localStorage.getItem('x-access-machine-token');
         const response = await OrdersFetchAPI.getTempOrderById(order._id, token);
         let dataOrder = response.data.pre_order

         if (deleted == true) {
            deletePreOrder(dataOrder.code, true)
         } else {
            setSelectPreOrder(dataOrder)
            selectedPreOrderRef.current = dataOrder; // Keep ref synced with fetched order
            getClientById(dataOrder.client_id)
         }

      } catch (err) {
         showApiError(err, {
            title: "No se pudo consultar la precuenta",
            message: "Error al consultar el detalle de la precuenta.",
            context: `pre_order_id=${order?._id || ""}`,
         }, ErrorAlert);

      }
   }

   // Fetch order quote details
   const getOrderQuote = async () => {
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      let business = JSON.parse(localStorage.getItem('business'))
      let machine = JSON.parse(localStorage.getItem('machine'));
      try {
         const responsePending = await OrdersFetchAPI.getOrdersTempPendingByClienId(business.code, branchoffice.code, minDate, maxDate, 0, 0, 0, 0, machine_token, 0, true)
         console.log("response quote", responsePending.data.temp_orders);

         let filter = responsePending.data.temp_orders.filter(quote => quote.is_authorized == true)
         setQuotes(filter)


      } catch (err) {
         setQuotes([])
         showApiError(err, {
            title: "No se pudieron cargar las cotizaciones",
            message: "Error al consultar las cotizaciones pendientes.",
         }, ErrorAlert);
      }
   }

   //update temporal autorization
   const updatePreOrder = async (data) => {
      let token = localStorage.getItem('x-access-machine-token');
      data.is_authorized = true
      try {
         //We update the temporal order
         await PreOrderFetchAPI.updateOrderTempPreOrder(
            {
               "_id": data._id,
               "status_id": data.status_id,
               "groups": data.groups,
               "is_authorized": true,
               "is_discount_notification": false,
               "is_pre_order": true,
               "combos": data.combos
            },
            token
         );

         getAll()
         ErrorAlert('', 'Orden autorizada', 'success')
      } catch (err) {
         showApiError(err, {
            title: "No se pudo autorizar la precuenta",
            message: "El servidor no pudo autorizar la precuenta.",
            context: `pre_order_id=${data?._id || ""}`,
         }, ErrorAlert);
      }
   }

   const handleSubmit = () => {
      const Toast = Swal.mixin({
         toast: true,
         position: "top-end",
         showConfirmButton: false,
         timer: 3000,
         timerProgressBar: true,
         didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
         }
      });
      Toast.fire({
         icon: "info",
         title: "Selecciona las precuentas a unir."
      });

      // Busca el radio button seleccionado dentro del grupo "options"
      const selectedRadio = document.querySelector('input[name="options-outlined-preOrder"]:checked');

      if (selectedRadio) {
         setDataPreOrderBind([JSON.parse(selectedRadio.value)])
         console.log(JSON.parse(selectedRadio.value));
      }
   };

   const addPreOrderToBind = (e, data) => {

      if (e.target.checked == true) {
         let newArray = []
         if (dataPreOrderBind.length == 0) {
            setDataPreOrderBind([data])
            newArray = [data]
         } else {
            dataPreOrderBind.forEach((order) => {
               if (order._id !== data._id) {
                  setDataPreOrderBind([...dataPreOrderBind, data])
                  newArray = [...dataPreOrderBind, data]
               }
            })
         }

         console.log(newArray);
      } else {
         let newArray = dataPreOrderBind.filter((order) => order._id !== data._id)
         setDataPreOrderBind(newArray)

         console.log(newArray);
      }
   }

   //delete preorder
   const deletePreOrder = async (code, quote) => {
      console.log(code);
      LoadingAlert()
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      let business = JSON.parse(localStorage.getItem('business'))
      let user = JSON.parse(localStorage.getItem('user'));

      let business_code = business.code
      let branch_code = branchoffice.code


      if (codeParthner != 0) {
         business_code = codeParthner.business_code
         branch_code = codeParthner.branchoffice_code
      }

      let jsonUpdate = {
         "order_code": code,
         "business_code": business_code,
         "branchoffice_code": branch_code,
         "justification": justification,
         "deleted": true,
         "status": 5,
         "user_id": user.id,
         "deleted_code": "USER_REQUEST"
      }
      try {
         //We save the preorder
         await DeletedTempOrdersFetchAPI.newDeletedTempOrder(jsonUpdate, machine_token);
         //We delete the preorder
         await PreOrderFetchAPI.deletePreOrder(jsonUpdate, machine_token)
         let message = "precuenta eliminada con exito."
         let title = "Precuenta eliminada"
         let icon = "success"
         ErrorAlert(message, title, icon)
         // Si la precuenta eliminada es la seleccionada, limpiar la previsualización

         console.log("preOrderInvoice", preOrderInvoice);
         if (preOrderInvoice == true) {
            if (code == dataPreOrder.code) {
               setPageLoader(1)
               setResetData(1)
            }
         }
         if (selectPreOrder && (selectPreOrder.code === code || selectPreOrder.order?.code === code)) {
            setSelectPreOrder({ order: "" });
         }



         getAll(quote)
      } catch (err) {
         showApiError(err, {
            title: "No se pudo eliminar la precuenta",
            message: "Esta precuenta pertenece a otra sucursal o no se pudo eliminar.",
            context: `order_code=${code || ""}`,
            icon: "warning",
         }, ErrorAlert);
      }
   }

   let intervalAply = 0
   const questionConfirmation = (dataNow) => {
      console.log("Enviando");
      if ((shoppingCart.length + shoppingCartCombos.length) > 0) {
         const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
               confirmButton: 'btn btn-success',
               cancelButton: 'btn btn-danger'
            },
            buttonsStyling: false
         })

         swalWithBootstrapButtons.fire({
            title: 'Aun hay productos en la cartilla',
            text: "¿Quieres aplicar la precuenta?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si aplicar!',
            cancelButtonText: 'No, cancelar!',
            reverseButtons: true
         }).then((result) => {
            if (result.isConfirmed) {
               swalWithBootstrapButtons.fire(
                  'Precuenta aplicada!',
                  'success'
               )
               setShoppingCart([]);
               setShoppingCartCombos([])
               setProductChecked([])
               setCombosChecked([])
               LoadingAlert()
               intervalAply = setInterval(() => { if (dataNow) { aplyPreOrder(dataNow) } else { aplyPreOrder() } }, 1000);

            } else if (
               /* Read more about handling dismissals below */
               result.dismiss === Swal.DismissReason.cancel
            ) {
               swalWithBootstrapButtons.fire(
                  'Precuenta no aplicada!',
                  '',
                  'info'
               )
            }
         })
      } else {
         setShoppingCart([]);
         setShoppingCartCombos([])
         setProductChecked([])
         setCombosChecked([])
         LoadingAlert()
         intervalAply = setInterval(() => { if (dataNow) { aplyPreOrder(dataNow) } else { aplyPreOrder() } }, 1000);

      }
   }

   const selectAction = (e, data) => {
      if (bind === false) {
         const parsed = JSON.parse(e.target.value);

         selectedPreOrderRef.current = parsed; // Keep the latest selection immediately
         setSelectPreOrder(parsed);
         setExpandedOrderId(parsed.client_i)

         if (parsed.client_id && parsed.client_id !== 0) getClientById(parsed.client_id);
         if (parsed.is_quote_order) getTemporalOrderById(parsed);
      } else {
         addPreOrderToBind(e, data);
      }
   };

   const aplyPreOrder = (dataNow) => {
      let dataSelectOrder = dataNow ?? selectedPreOrderRef.current ?? selectPreOrder;
      if (dataNow != undefined) {
         dataSelectOrder = dataNow
      }

      localStorage.setItem('preOrderComparativeOld', JSON.stringify(dataSelectOrder))
      clearInterval(intervalAply)
      let message = ""
      let title = ""
      let icon = ""
      ErrorAlert(message, title, icon)
      if (dataSelectOrder.order == "") {
         console.log("no hay pre cuenta seleccionada");
         message = "No ha selecciona ninguna precuenta."
         title = "Bebe seleccionar una precuenta."
         icon = "info"
         ErrorAlert(message, title, icon)
      } else {

         setDataPreOrder({ pre_Order: true, _id: dataSelectOrder._id, code: dataSelectOrder.code, status_id: dataSelectOrder.status_id, transaction_code: dataSelectOrder.transaction_code, event_id: dataSelectOrder.event_id, justification: dataSelectOrder.justification })
         setDataReferenceOrderMicros(dataSelectOrder.micros_reference)
         setName(dataSelectOrder.client_name)
         if (dataSelectOrder?.event_id) { setEventSelect?.({ id: dataSelectOrder.event_id }); }

         setAddresDescriptionClientFiscal(dataSelectOrder.client_address ? dataSelectOrder.client_address : "")
         setAditional_data(dataSelectOrder.aditional_info ? dataSelectOrder.aditional_info : "")

         if (clientDataByTemporalOrder != null) {
            localStorage.setItem('client_data', JSON.stringify(clientDataByTemporalOrder));
            setdataClientSelected(clientDataByTemporalOrder);
            setClientDataByTemporalOrder(null)
         }


         if (dataSelectOrder.client_ruc && dataSelectOrder.client_dv) {
            setRuc(dataSelectOrder.client_ruc)
            setDv(dataSelectOrder.client_dv)
         } else {
            setRuc("0")
            setDv("0")
         }


         if (dataSelectOrder.table_id && dataSelectOrder.table_code) {
            setTableInfo({ table_id: dataSelectOrder.table_id, table_code: dataSelectOrder.table_code, table_name: dataSelectOrder.table_name })
         } else {
            setTableInfo({ table_id: 0, table_code: "", table_name: "" })
         }

         setDataResponse(true)
         setOptionalData(true)
         setShowModalNew(false)


         //format json 
         for (let i = 0; i < dataSelectOrder.groups.length; i++) {

            for (let s = 0; s < dataSelectOrder.groups[i].segments.length; s++) {

               dataSelectOrder.groups[i].segments[s].img = dataSelectOrder.groups[i].segments[s].item.img
               dataSelectOrder.groups[i].segments[s].item_id = dataSelectOrder.groups[i].segments[s].item.item_id
               dataSelectOrder.groups[i].segments[s].name = dataSelectOrder.groups[i].segments[s].item.name
               dataSelectOrder.groups[i].segments[s].segment_name = dataSelectOrder.groups[i].segments[s].name
               dataSelectOrder.groups[i].segments[s].cantidadItem = dataSelectOrder.groups[i].segments[s].item.amount
               dataSelectOrder.groups[i].segments[s].description = dataSelectOrder.groups[i].segments[s].item.description
               dataSelectOrder.groups[i].segments[s].tax = dataSelectOrder.groups[i].segments[s].item.tax
               dataSelectOrder.groups[i].segments[s].price = dataSelectOrder.groups[i].segments[s].item.price
            }
            dataSelectOrder.groups[i].DetalleSegmentos = dataSelectOrder.groups[i].segments
            dataSelectOrder.groups[i].cantidadItem = dataSelectOrder.groups[i].amount
            dataSelectOrder.groups[i].amount_Original = dataSelectOrder.groups[i].amount
            dataSelectOrder.groups[i].descuento = dataSelectOrder.groups[i].discount
         }


         message = "Orden consultada."
         title = "Operacion exitosa"
         icon = "success"
         setdataDiscountApply(dataSelectOrder.discounts)
         setPreOrderInvoice(true);
         setTaxesArrayAll(dataSelectOrder.taxes)
         ErrorAlert(message, title, icon)
         setCheckDeliveryOrder(dataSelectOrder.order_type)
         setShoppingCart(normalizeRecoveredPreOrderItems(dataSelectOrder.groups))
         setShoppingCartCombos(normalizeRecoveredPreOrderItems(dataSelectOrder.combos))
         setInvoiceTotal(dataSelectOrder.total)
         setInvoiceSubtotal(dataSelectOrder.subtotal)
         setInvoiceTotalItbms(dataSelectOrder.tax)

         setInvoiceTotalDiscount(dataSelectOrder.discount)
         setEventHandler(1)
         //We clean the url of parameters
         const cleanUrl = window.location.origin + window.location.pathname;
         window.history.replaceState({}, document.title, cleanUrl);
      }
   }

   const cleanStates = () => {
      setBind(false)
      setDataPreOrderBind([])
      setShopingcartBind([])
      setShopingcartComboBind([])
      resetInputs()
      setSelectPreOrder({ order: "" })
      //We clean the references 
      selectedPreOrderRef.current = null;
      //We clean the url of parameters
      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);

   }

   const filteredPreOrders = useMemo(() => {
      if (!search.trim()) return preOrders;
      const term = search.trim().toLowerCase();
      return preOrders.filter(p =>
         (p.transaction_code && p.transaction_code.toString().toLowerCase().includes(term)) ||
         (p.client_name && p.client_name.toLowerCase().includes(term)) ||
         (p.table_name && p.table_name.toLowerCase().includes(term))
      );
   }, [preOrders, search]);


   const filteredQuotesOrders = useMemo(() => {
      if (!search.trim()) return quotes;
      const term = search.trim().toLowerCase();
      return quotes.filter(p =>
         (p.transaction_code && p.transaction_code.toString().toLowerCase().includes(term)) ||
         (p.client_name && p.client_name.toLowerCase().includes(term)) ||
         (p.table_name && p.table_name.toLowerCase().includes(term))
      );
   }, [quotes, search]);


   useEffect(() => {
      console.log("dominio del negocion:", domain);
      (async () => {


         try {
            let business = ''
            let token = ''
            let branchoffice = ''
            if (localStorage.getItem("branchoffice") !== "" || localStorage.getItem("branchoffice") !== null || localStorage.getItem("branchoffice") !== undefined) {

               business = JSON.parse(localStorage.getItem("business"))
               branchoffice = JSON.parse(localStorage.getItem("branchoffice"))

            }

            //We get the branchoffice info 
            const response_branch = await BranchOfficeFetchAPI.getBranchOfficeByCode(business.code, branchoffice.code);
            //We set the business data 
            setBranchofficeData(response_branch.data.branchoffice);

         } catch (err) {
            setBranchofficeData({
               "ruc": "",
               "dv": "",
               "name": "",
               "ruc_type": "",
               "direction": "",
               "dgi_name": "",
            })
         }
      })();
   }, [domain]);

   const resetInputs = () => {
      setSelectedInputs([]);
      inputRefs.current.forEach(input => {
         if (input) {
            input.checked = false;
         }
      });
   };

   const handleInputChange = (e, index) => {
      const { name, checked } = e.target;
      console.log("Input change:", name, checked, index);
      setSelectedInputs(prevState => {
         const newState = [...prevState];
         newState[index] = checked ? name : '';
         return newState;
      });
   };

   useEffect(() => {
      (async () => {
         console.log("auto open", autoOpen);
         if (!autoOpen) return;
         if (didAutoOpenRef.current) return;
         await getAll(false);
         didAutoOpenRef.current = true;
      })();
   }, [autoOpen]);

   useEffect(() => {
      didAutoOpenRef.current = false;
      didAutoSelectRef.current = false;
   }, [autoSelectOrderId]);

   useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      const preOrder = (params.get('pre_order') || '').toLowerCase() === 'true';
      const orderId = params.get('order_id');

      if (!preOrder || !orderId) return;
      if (!showModal) return;
      if (didAutoSelectRef.current) return;

      // English comment: fetch and auto-apply the temporal order
      getTemporalOrderById({ _id: orderId }, false, true);
      didAutoSelectRef.current = true;
   }, [showModal, location.search]);



   const [activeTab, setActiveTab] = useState("precuentas");
   /* ── Icons ─────────────────────────────────────── */
   const SearchIcon = () => (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2">
         <circle cx="11" cy="11" r="8" />
         <path d="m21 21-4.35-4.35" />
      </svg>
   );


   const ChevronIcon = ({ open }) => (
      <svg
         className={`precuenta-order__chevron ${open ? "precuenta-order__chevron--open" : ""}`}
         viewBox="0 0 24 24"
         fill="none"
         stroke="currentColor"
         strokeWidth="2"
      >
         <path d="m6 9 6 6 6-6" />
      </svg>
   );


   const [expandedOrderId, setExpandedOrderId] = useState(null);
   const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
   const [hasUserSelected, setHasUserSelected] = useState(false);
   // Estado para modal de detalles de cotización
   const [showQuoteDetails, setShowQuoteDetails] = useState(false);
   const [selectedQuote, setSelectedQuote] = useState(null);
   useEffect(() => {
      const check = () => setIsMobile(window.innerWidth <= 600);
      window.addEventListener("resize", check);
      return () => window.removeEventListener("resize", check);
   }, []);

   useEffect(() => {
      if (showModal) {
         setHasUserSelected(false);
         setExpandedOrderId(null);
      }
   }, [showModal]);

   useEffect(() => { if (activeTab === "cotizaciones") { getOrderQuote() } }, [activeTab])

   return (
      <>


         {/* <button className='responsive-btn p-2 bg-secondary bg-opacity-10 rounded-3 text-secondary' onClick={getAll}>
            <i class="uil uil-receipt icon"></i>
            <small className='fw-bold text'> Precuentas </small>
         </button> */}


         <button className={`sp-seg__btn`} onClick={getAll} >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M5 3h14v18l-2.5-1.6L14 21l-2-1.6L10 21l-2.5-1.6L5 21z" /><line x1="9" y1="8" x2="15" y2="8" /></svg>
            Precuentas

            {/* <span className="ct"> {filteredPreOrders.length}</span> */}
         </button>



         {/* Modal */}
         {showModal && (
            <div className="modal-backdrop-custom"
               onClick={() => (setShow(false))}
            >


               <div className="precuenta-modal">
                  {/* ── Header ──────────────────────────────── */}
                  <div className="precuenta-header">
                     <div className="d-flex flex-column align-items-start">
                        <p className="precuenta-header__title">Precuenta</p>
                        <p className="precuenta-header__sub">
                           Seleccione una orden para enviarla al carrito
                        </p>
                     </div>
                     <div className="precuenta-tabs">
                        {["precuentas", "cotizaciones"].map((tab) => (
                           <button
                              key={tab}
                              className={`precuenta-tab ${activeTab === tab ? "precuenta-tab--active" : ""}`}
                              onClick={() => setActiveTab(tab)}
                           >
                              {tab.charAt(0).toUpperCase() + tab.slice(1)}
                           </button>
                        ))}
                     </div>
                  </div>
                  {/* ── Body ────────────────────────────────── */}
                  <div className="precuenta-body">
                     {/* ── Precuentas view ───────────────────── */}
                     <div className={`precuenta-precuentas-view ${activeTab !== "precuentas" ? "precuenta-precuentas-view--hidden" : ""}`} >
                        {/* Sidebar / mobile list */}
                        <div className="precuenta-sidebar">
                           <div className="precuenta-search">
                              <SearchIcon />
                              <input
                                 className="precuenta-search__input"
                                 placeholder="Buscar ordenes..."
                                 // value={orderSearch}
                                 onChange={e => setSearch(e.target.value)}
                              />
                           </div>
                           {!filteredPreOrders.length
                              ? <> <p className="precuenta-no-results">No se encontraron ordenes</p> </>
                              :

                              <>
                                 {filteredPreOrders.map((order, index) => {
                                    const count = order.groups.length + order.combos.length;
                                    const isExpanded = isMobile && expandedOrderId === order.code;

                                    return (
                                       <div key={order.code} className='precuenta-order__card--open'>
                                          <input
                                             className="btn-check-sp input-visually-hidden"
                                             type={bind === false ? "radio" : "checkbox"}
                                             autoComplete="off"
                                             value={JSON.stringify(order)}
                                             name="options-outlined-preOrder"
                                             id={order.code + "preOrder"}
                                             onChange={(e) => {
                                                selectAction(e, order);
                                                handleInputChange(e, index);
                                                setHasUserSelected(true);
                                                // Toggle accordion en mobile
                                                if (isMobile) {
                                                   setExpandedOrderId((prev) =>
                                                      prev === order.code ? null : order.code
                                                   );
                                                }
                                             }}
                                             ref={(el) => (inputRefs.current[index] = el)}
                                          />

                                          <label
                                             htmlFor={order.code + "preOrder"}
                                             className="precuenta-order w-100"
                                          >
                                             <div className="precuenta-order__top">
                                                <span className="precuenta-order__num rounded-pill border px-2">
                                                   Orden #{order.transaction_code}
                                                </span>
                                                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                                   <span className="precuenta-order__date">
                                                      {order.createdAt.slice(0, 10)}
                                                   </span>
                                                   <ChevronIcon open={isExpanded} />
                                                </div>
                                             </div>

                                             <p className="precuenta-order__meta d-flex flex-column align-items-start mb-0 mt-2">
                                                {order.table_name != 0 &&
                                                   order.table_name != null &&
                                                   order.table_name != undefined ? (
                                                   <>{order.table_name ? `Mesa ${order.table_name} · ` : ""}</>
                                                ) : null}
                                                {order.client_name} / {order.branchoffice.name}
                                             </p>

                                             <p className="precuenta-order__summary d-flex flex-column align-items-start mt-0">
                                                {count} Producto{count !== 1 ? "s" : ""} · ${parseFloat(order.total).toFixed(2)}
                                             </p>

                                             {order.justification !== "" && (
                                                <div className="precuenta-order__meta d-flex flex-column align-items-start mb-0 mt-2">
                                                   <span className="precuenta-order__meta mb-0 mt-2 fw-bolder">
                                                      Justificacion:
                                                   </span>
                                                   <p className="precuenta-order__meta d-flex flex-column align-items-start mb-0">
                                                      {order.justification}
                                                   </p>
                                                </div>
                                             )}

                                             {order.ecommerce_order === true && (
                                                <div className="mt-2 d-flex gap-3">
                                                   <span className="precuenta-order__meta mb-0 mt-2 fw-bolder">
                                                      Cobro en línea
                                                   </span>
                                                   <button
                                                      className="precuenta-btn-secondary"
                                                      onClick={(e) => {
                                                         e.preventDefault(); // Evita que el label active el input
                                                         setOrderForSendLink(order);
                                                         setSendLinkPayment(true);
                                                      }}
                                                   >
                                                      <i className="fa-solid fa-share"></i> Enviar link
                                                   </button>
                                                   <ModalSendLinkPayment
                                                      sendLinkPayment={sendLinkPayment}
                                                      setSendLinkPayment={setSendLinkPayment}
                                                      PreOrderDataCallCenter={orderForSendLink}
                                                      dataClientSelected={null}
                                                      dataOrder={null}
                                                      domain={domain}
                                                   />
                                                </div>
                                             )}

                                             <div className="d-flex justify-content-end mt-2 align-items-center">
                                                <div className="glass-actions">
                                                   {bind === false && (
                                                      <ModalDivisionPreOrder
                                                         order={order}
                                                         getAll={getAll}
                                                         onPendingDelete={hidePreOrderPendingDelete}
                                                         codeParthner={codeParthner}
                                                         resetInputs={resetInputs}
                                                         orderNumberNow={orderNumberNow}
                                                         getOrderNumber={getOrderNumber}
                                                      />
                                                   )}
                                                </div>
                                                <RenderIf
                                                   isTrue={
                                                      bind === false &&
                                                      checkUserPermission(
                                                         "delete_pre_orders",
                                                         user.permissions ?? []
                                                      ) !== -1
                                                   }
                                                >
                                                   <div className="d-flex justify-content-end">
                                                      <ModalJustification
                                                         setJustification={setJustification}
                                                         deletePreOrder={deletePreOrder}
                                                         order={order.code}
                                                      />
                                                   </div>
                                                </RenderIf>

                                             </div>
                                          </label>


                                          {/* ▼ FUERA del label — accordion mobile */}
                                          <div
                                             className={`precuenta-accordion-detail ${isExpanded ? "precuenta-accordion-detail--open" : ""
                                                }`}
                                          >
                                             <OrderPreview order={order} />
                                          </div>
                                       </div>
                                    );
                                 })}
                              </>

                           }
                        </div>
                        {/* 
                        <div className="precuenta-detail">
                           <OrderPreview order={selectPreOrder} ></OrderPreview>
                        </div>
             */}

                        {/* Desktop detail panel */}
                        {!isMobile && (
                           hasUserSelected && selectPreOrder ? (
                              <div className="precuenta-detail" data-qa-selected-preorder-code={selectPreOrder?.code || ""}>
                                 <OrderPreview order={selectPreOrder} />
                              </div>
                           ) : (
                              <div className="precuenta-empty">
                                 <svg
                                    className="precuenta-empty__icon"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                 >
                                    <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
                                    <rect x="9" y="3" width="6" height="4" rx="1" />
                                    <path d="M9 12h6" />
                                    <path d="M9 16h6" />
                                 </svg>
                                 <p className="precuenta-empty__title">
                                    Ninguna orden seleccionada
                                 </p>
                                 <p className="precuenta-empty__sub">
                                    Seleccione una orden de la lista para ver su información
                                 </p>
                              </div>
                           )
                        )}


                     </div>


                     {/* ── Cotizaciones view ─────────────────── */}
                     <div className={`precuenta-cotizaciones-view ${activeTab === "cotizaciones" ? "precuenta-cotizaciones-view--active" : ""
                        }`}

                     >
                        <div className="p-lg-4 p-1 p-md-2 item2 list-framer-precuentas border ">
                           <div className='row'>


                              {!quotes.length
                                 ? <Empty title="Vacío" msg="No hay ordenes pendientes" />
                                 : quotes.map((order, index) => (
                                    <>


                                       <div className='col-lg-4 col-md-6 col-12 mb-3 '>
                                          <div className="btn-group w-100 h-100" role="group" >
                                             <input

                                                className="btn-check-sp input-visually-hidden"

                                                type={bind == false ? "radio" : "checkbox"}
                                                autocomplete="off" value={JSON.stringify(order)} name="options-outlined-quote" id={order._id + "quote"}
                                                onChange={(e) => (selectAction(e, order), handleInputChange(e, index))}

                                                ref={el => inputRefs.current[index] = el}

                                             />
                                             <label
                                                htmlFor={order._id + "quote"}
                                                className={`btn btn-choice p-lg-2 p-1  border `}>


                                                <div key={order.id}>
                                                   <div className="glass-card-preacounts">
                                                      <div className="glass-header">
                                                         <h2 className="glass-order-id">
                                                            <i class="uil uil-invoice"></i>
                                                            Cotizacion: {order.transaction_code}</h2>
                                                      </div>

                                                      <div className="glass-body">

                                                         <div className="glass-info">
                                                            <span className="glass-label">Cliente</span>
                                                            <span className="glass-value">{order.client_name}</span>
                                                         </div>
                                                         <div className="glass-info">
                                                            <span className="glass-label">Telefono</span> <br></br>
                                                            <span className="glass-value">{order.client_phone}</span>
                                                         </div>
                                                         {order.client_email && (<div className="glass-info">
                                                            <span className="glass-label">Email</span>
                                                            <span className="glass-value">{order.client_email}</span>
                                                         </div>)}

                                                         <div className="glass-info">
                                                            <span className="glass-label">Ruc</span>
                                                            <span className="glass-value">{order.client_ruc}</span>
                                                         </div>
                                                         <div className="glass-info">
                                                            <span className="glass-label">Dv</span>
                                                            <span className="glass-value">{order.client_dv}</span>
                                                         </div>
                                                         <div className="glass-info">
                                                            <span className="glass-label">Sucursal</span>
                                                            <span className="glass-value">{order.branchoffice.name}</span>
                                                         </div>

                                                         <div className="glass-info">
                                                            <span className="glass-label">Fecha</span>
                                                            <span className="glass-value">{order.createdAt.slice(0, 10)}</span>
                                                         </div>

                                                         {order.note && (
                                                            <div className='container mb-3'>
                                                               <div className="p-2 bg-light rounded border">
                                                                  <h5 className="mb-2 text-primary">Nota de la cotizacion</h5>
                                                                  <p>{order.note}</p>
                                                               </div>
                                                            </div>
                                                         )}

                                                         {order.files && Array.isArray(order.files) && order.files.length > 0 && (
                                                            <div className='container mb-3'>
                                                               <div className="p-2 bg-light rounded border">
                                                                  <h5 className="mb-2 text-primary">Archivos adjuntos</h5>
                                                                  <ul className="mb-0 d-flex justify-content-start flex-wrap">
                                                                     {order.files.map((file, idx) => (
                                                                        <li key={idx} className="d-flex m-1">
                                                                           <a
                                                                              href={file.url || file}
                                                                              target="_blank"
                                                                              rel="noopener noreferrer"
                                                                              download
                                                                              className="btn btn-outline-primary btn-sm d-flex align-items-center"
                                                                              title={file.url ? file.url.split('/').pop() : (file.name || 'Archivo adjunto')}
                                                                           >
                                                                              <i className="uil uil-file-alt" /> {'Archivo adjunto ' + (idx + 1)}
                                                                           </a>
                                                                        </li>
                                                                     ))}
                                                                  </ul>
                                                               </div>
                                                            </div>
                                                         )}

                                                         {order.ecommerce_order == true ? <>

                                                            <div className="glass-info">
                                                               <span className="glass-label">Cobro en linea</span>
                                                               <span className="glass-value">

                                                                  <button className='btn btn-outline-success bg-success-subtle border-0 border-0  btn-sm' onClick={() => { setOrderForSendLink(order); setSendLinkPayment(true) }} >

                                                                     <i class="fa-solid fa-share"></i>  Enviar link

                                                                  </button>
                                                                  <ModalSendLinkPayment sendLinkPayment={sendLinkPayment} setSendLinkPayment={setSendLinkPayment} PreOrderDataCallCenter={orderForSendLink} dataClientSelected={null} dataOrder={null} domain={domain} />
                                                               </span>
                                                            </div>



                                                         </> : <></>}






                                                         {/*} <div style={{ marginTop: '0.5rem' }}>
                                                                     <span className="glass-badge">{(order.groups.length + order.combos.length)} productos</span>
                                                                  </div>*/}

                                                         <div className='d-flex justify-content-between mt-2 border-top align-items-center'>

                                                            <div className="glass-actions ">

                                                               {/*   <PDFDownloadLink className='m-0 p-0' document={
                                                                           <InvoicePDF
                                                                              data={{
                                                                                 emisor: order.branchoffice.fiscal_name,
                                                                                 emisorRuc: order.branchoffice.ruc,
                                                                                 emisorDv: order.branchoffice.dv,
                                                                                 emisorDireccion: branchOfficeData.direction,
                                                                                 clienteNombre: order.client_name,
                                                                                 clienteRuc: order.client_ruc,
                                                                                 clienteDv: order.client_dv,
                                                                                 clienteDireccion: order.client_address,
                                                                                 clienteTelefono: order.client_phone,
                                                                                 fechaEmision: order.createdAt ? new Date(order.createdAt).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '',
                                                                                 puntoFacturacion: "",
                                                                                 consultaClaveUrl: "",
                                                                                 cufe: "",
                                                                                 items: order.groups,
                                                                                 itbmsBreakdown: order.taxes,
                                                                                 metodoPago: "",
                                                                                 formaPagoMonto: "",
                                                                                 totalPagado: order.total,
                                                                                 tips: order.tips,
                                                                                 subtotal: order.subtotal,
                                                                                 discount: order.discount,
                                                                                 tax: order.tax,
                                                                                 total: order.total,
                                                                                 typeDocument: "quote",
                                                                                 logo: logo,
                                                                                 aditional_info: order.aditional_info ? order.aditional_info : ""


                                                                              }} />
                                                                        }>
                                                                           <button className='btn btn-outline-secondary border-0 border-0  btn-sm border-end' >
                                                                              <i class="uil uil-file-download-alt "></i> Cotizacion lkj </button>
                                                                        </PDFDownloadLink> */}

                                                            </div>

                                                            <div className="d-flex justify-content-end mt-3">
                                                               <button
                                                                  className="btn btn-outline-primary btn-sm"
                                                                  onClick={e => {
                                                                     e.preventDefault();
                                                                     setSelectedQuote(order);
                                                                     setShowQuoteDetails(true);
                                                                  }}
                                                               >
                                                                  <i className="uil uil-eye"></i> Ver detalles
                                                               </button>
                                                            </div>
                                                            <button className='btn btn-outline-danger border-0 mt-2 btn-sm'
                                                               data-order={order.code}
                                                               onClick={async (e) => getTemporalOrderById(order, true)}>
                                                               <i className="uil uil-trash-alt"> </i>
                                                            </button>


                                                         </div>

                                                      </div>
                                                   </div>
                                                </div >
                                             </label>
                                          </div>
                                       </div>
                                    </>
                                 ))
                              }
                           </div>

                        </div>


                     </div>
                  </div>



                  {/* ── Footer ──────────────────────────────── */}
                  <div className="precuenta-footer">

                     {activeTab === "precuentas"


                        ? <>

                           <div className="precuenta-footer__actions">
                              <button className="sp-pre__btn sp-pre__btn--cancel text-danger" onClick={() => (setShowModalNew(false), cleanStates())} >
                                 Cancelar
                              </button>

                              {bind == false ? <>
                                 <button class="pp-btn ghost" type="button"
                                    onClick={() => (setBind(true), handleSubmit())}>
                                    <i class="uil uil-arrow-compress-h"></i>Unir
                                 </button>

                                 <button class="pp-btn primary" type="button"
                                    onClick={() => (questionConfirmation())}><i class="uil uil-store"></i>  Enviar al carrito </button>
                              </> : <>

                                 <button className='btn bg-primary-subtle text-primary  border-0 fw-bold '
                                    onClick={() => (cleanStates())}><i class="uil uil-previous"></i> Volver </button>

                                 <Modalblind showModalBind={showModalBind} setShowModalBind={setShowModalBind} shoppingCart={shopingcartBind} setShopingcartBind={setShopingcartBind} shoppingCartCombos={shopingcartComboBind} setShopingcartComboBind={setShopingcartComboBind} dataPreOrderBind={dataPreOrderBind} codeParthner={codeParthner} getAll={getAll} cleanStates={cleanStates} orderNumberNow={orderNumberNow} getOrderNumber={getOrderNumber}></Modalblind>


                              </>}
                           </div>

                        </>
                        : <>
                           <div className="precuenta-footer__actions">
                              <button className="sp-pre__btn sp-pre__btn--cancel text-danger" onClick={() => (setShowModalNew(false), cleanStates())} >
                                 Cancelar
                              </button>
                              <div className="">
                                 <button
                                    class="pp-btn primary" type="button"
                                    onClick={() => (questionConfirmation())}
                                 >
                                    Enviar al carrito
                                 </button>
                              </div>
                           </div>
                        </>
                     }
                  </div>
               </div>











               <div
                  className="bg-white rounded-4 shadow-lg modal-content-custom d-none "
                  style={{ maxWidth: '1300px', width: '100%', height: '100%' }}
                  onClick={(e) => e.stopPropagation()}
               >

                  {/* Header */}
                  <div className="header-gradient-preacounts text-white p-4 position-relative rounded-top-4">
                     <button className="btn-close-custom position-absolute top-0 end-0 m-3 p-2 rounded-circle " onClick={() => (setShowModalNew(false), cleanStates())} >
                        <i class="fa-solid fa-xmark"></i>
                     </button>
                     <div className="flex-grow-1">
                        <h2 className="h3 fw-bold mb-2">
                           Precuenta


                        </h2>



                        <p className="mb-0 small opacity-90 d-flex align-items-center gap-1">
                           <i className="uil uil-info-circle me-1"></i>
                           Por favor, seleccione una orden para enviarla al carrito.</p>
                     </div>
                  </div>

                  <Tab.Container defaultActiveKey="preaccounts" >
                     <Row>
                        <Col sm={12} >
                           <Nav variant="pills" className="d-flex horizontal-scroll bg-white rounded-3 gap-3 m-3" >
                              <li className="nav-sp-item bg-light rounded-3 border"  >
                                 <Nav.Link eventKey="preaccounts" title="preaccounts"><i class="uil uil-file-alt"></i> Precuentas</Nav.Link>
                              </li>
                              <div onClick={() => getOrderQuote()}>
                                 <li className="nav-sp-item bg-light rounded-3 border"  >
                                    <Nav.Link eventKey="quote" title="quote"><i class="uil uil-file-bookmark-alt"></i> Cotizaciones</Nav.Link>
                                 </li>
                              </div>
                           </Nav>
                        </Col>
                        <Col sm={12}>
                           <Tab.Content>
                              <Tab.Pane eventKey="preaccounts">
                                 {/* Content */}

                                 <div className='row'>

                                    <div className="col-md-4 p-lg-4 p-1 p-md-2 item2 list-framer-precuentas border ">
                                       <div className=''>

                                          <div style={{ position: "sticky", top: 0, zIndex: 10, background: "#fff", paddingBottom: 8 }} className='m-3'>
                                             <div className='flex-fill bd-highlight search-bar'>
                                                <form className="w-100">
                                                   <div className='d-flex justify-content-start align-items-center p-0 m-0'>
                                                      <i className="uil uil-search icon-mobile"></i>
                                                      <h2 className="glass-order-id"><i className="uil uil-search"></i></h2>
                                                      <input
                                                         id='searchInput'
                                                         spellCheck="false"
                                                         className="form-control rounded-3 form-control-sm mx-2 bg-gray"
                                                         type="text"
                                                         step="any"
                                                         placeholder="Buscar ordenes..."
                                                         onChange={e => setSearch(e.target.value)}
                                                      />
                                                   </div>
                                                </form>
                                             </div>
                                          </div>
                                          {!filteredPreOrders.length
                                             ? <Empty title="Vacío" msg="No hay ordenes pendientes" />
                                             : filteredPreOrders.map((order, index) => (
                                                <>


                                                   <div className='col-lg-12 col-md-12  col-12 mb-3 '>
                                                      <div className="btn-group w-100 h-100" role="group" >
                                                         <input

                                                            className="btn-check-sp input-visually-hidden"

                                                            type={bind == false ? "radio" : "checkbox"}
                                                            autocomplete="off" value={JSON.stringify(order)} name="options-outlined-preOrder" id={order.code + "preOrder"}
                                                            onChange={(e) => (selectAction(e, order), handleInputChange(e, index))}
                                                            ref={el => inputRefs.current[index] = el}

                                                         />
                                                         <label
                                                            htmlFor={order.code + "preOrder"}
                                                            className={`btn btn-choice p-lg-2 p-1  border `}>


                                                            <div key={order.id}>
                                                               <div className="glass-card-preacounts">
                                                                  <div className="glass-header">
                                                                     <h2 className="glass-order-id">
                                                                        <i class="uil uil-invoice"></i>
                                                                        Order: {order.transaction_code}</h2>
                                                                  </div>
                                                                  <div className="glass-body">
                                                                     {order.table_name != 0 && order.table_name != null && order.table_name != undefined ? <>
                                                                        <div className="glass-info">
                                                                           <span className="glass-label"> Mesa:
                                                                           </span>
                                                                           <span className="glass-value"> {order.table_name}
                                                                           </span>
                                                                        </div>
                                                                     </> : <></>}
                                                                     <div className="glass-info">
                                                                        <span className="glass-label">Cliente</span>
                                                                        <span className="glass-value">{order.client_name}</span>
                                                                     </div>
                                                                     <div className="glass-info">
                                                                        <span className="glass-label">Sucursal</span>
                                                                        <span className="glass-value">{order.branchoffice.name}</span>
                                                                     </div>
                                                                     <div className="glass-info">
                                                                        <span className="glass-label">Fecha</span>
                                                                        <span className="glass-value">{order.createdAt.slice(0, 10)}</span>
                                                                     </div>

                                                                     {order.ecommerce_order == true ? <>

                                                                        <div className="glass-info">
                                                                           <span className="glass-label">Cobro en linea</span>
                                                                           <span className="glass-value">

                                                                              <button className='btn btn-outline-success bg-success-subtle border-0 border-0  btn-sm' onClick={() => { setOrderForSendLink(order); setSendLinkPayment(true) }} >

                                                                                 <i class="fa-solid fa-share"></i>  Enviar link

                                                                              </button>
                                                                              <ModalSendLinkPayment sendLinkPayment={sendLinkPayment} setSendLinkPayment={setSendLinkPayment} PreOrderDataCallCenter={orderForSendLink} dataClientSelected={null} dataOrder={null} domain={domain} />
                                                                           </span>
                                                                        </div>



                                                                     </> : <></>}

                                                                     {order.justification != ""
                                                                        ? <>

                                                                           <div className="glass-info">
                                                                              <span className="glass-label">Justificacion</span>
                                                                              <span className="glass-value">{order.justification}</span>
                                                                           </div>
                                                                        </>
                                                                        : <></>}

                                                                     <div style={{ marginTop: '0.5rem' }}>
                                                                        <span className="glass-badge">{(order.groups.length + order.combos.length)} productos</span>
                                                                     </div>

                                                                     <div className='d-flex justify-content-between mt-2 border-top align-items-center'>

                                                                        <div className="glass-actions ">

                                                                           {/* <PDFDownloadLink className='m-0 p-0' document={<InvoicePDF
                                                                           data={{
                                                                              emisor: order.branchoffice.fiscal_name,
                                                                              emisorRuc: order.branchoffice.ruc,
                                                                              emisorDv: order.branchoffice.dv,
                                                                              emisorDireccion: "",
                                                                              clienteNombre: order.client_name,
                                                                              clienteRuc: order.client_ruc,
                                                                              clienteDv: order.client_dv,
                                                                              clienteDireccion: order.client_address,
                                                                              clienteTelefono: order.client_phone,
                                                                              fechaEmision: order.createdAt ? new Date(order.createdAt).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '',
                                                                              puntoFacturacion: "",
                                                                              consultaClaveUrl: "",
                                                                              cufe: "",
                                                                              items: order.groups,
                                                                              itbmsBreakdown: order.taxes,
                                                                              metodoPago: "",
                                                                              formaPagoMonto: "",
                                                                              totalPagado: order.total,
                                                                              tips: order.tips,
                                                                              subtotal: order.subtotal,
                                                                              discount: order.discount,
                                                                              tax: order.tax,
                                                                              total: order.total,
                                                                              typeDocument: "quote",
                                                                              logo: logo


                                                                           }} />} >
                                                                           <button className='btn btn-outline-secondary border-0 border-0  btn-sm border-end' >
                                                                              <i class="uil uil-file-download-alt "></i> Precuenta </button>
                                                                        </PDFDownloadLink> */}
                                                                           {bind == false ? <>
                                                                              <ModalDivisionPreOrder order={order} getAll={getAll} onPendingDelete={hidePreOrderPendingDelete} codeParthner={codeParthner} resetInputs={resetInputs} ></ModalDivisionPreOrder>
                                                                           </> : <></>}
                                                                        </div>
                                                                        {/** Delete button of pre-order */}
                                                                        <RenderIf isTrue={bind == false && checkUserPermission("delete_pre_orders", user.permissions == undefined ? [] : user.permissions) !== -1}>
                                                                           <div className='d-flex justify-content-end'>
                                                                              <ModalJustification setJustification={setJustification} deletePreOrder={deletePreOrder} order={order.code} ></ModalJustification>
                                                                           </div>
                                                                        </RenderIf>

                                                                     </div>

                                                                  </div>
                                                               </div>
                                                            </div >
                                                         </label>
                                                      </div>
                                                   </div>
                                                </>
                                             ))
                                          }
                                       </div>

                                    </div>

                                    <div className="col-md-8 p-lg-4   item2 list-framer-precuentas border " data-qa-selected-preorder-code={selectPreOrder?.code || ""}>
                                       setSelectPreOrder
                                       <OrderPreview order={selectPreOrder} ></OrderPreview>

                                    </div>
                                 </div>

                                 <div className='d-block mt-lg-1 mt-0 '>
                                    <div className='d-flex justify-content-between justify-content-lg-endn  mx-2 p-2'>

                                       <button className='btn bg-danger-subtle text-danger  border-0 fw-bold '
                                          onClick={() => (setShowModalNew(false), cleanStates())}><i class="uil uil-times-circle"></i> Cancelar </button>

                                       {bind == false ? <>
                                          <button className='btn bg-primary-subtle text-success fw-bold border-0 ms-1'
                                             onClick={() => (setBind(true), handleSubmit())}>
                                             <i class="uil uil-arrow-compress-h"></i>Unir
                                          </button>

                                          <button className='btn bg-success-subtle text-success fw-bold border-0 ms-1 '
                                             onClick={() => (questionConfirmation())}><i class="uil uil-store"></i>  Enviar al carrito </button>
                                       </> : <>

                                          <button className='btn bg-primary-subtle text-primary  border-0 fw-bold '
                                             onClick={() => (cleanStates())}><i class="uil uil-previous"></i> Volver </button>

                                          <Modalblind showModalBind={showModalBind} setShowModalBind={setShowModalBind} shoppingCart={shopingcartBind} setShopingcartBind={setShopingcartBind} shoppingCartCombos={shopingcartComboBind} setShopingcartComboBind={setShopingcartComboBind} dataPreOrderBind={dataPreOrderBind} codeParthner={codeParthner} getAll={getAll} cleanStates={cleanStates} getOrderNumber={getOrderNumber}></Modalblind>


                                       </>}
                                    </div>
                                 </div>

                              </Tab.Pane>

                              <Tab.Pane eventKey="quote">
                                 <div className="p-lg-4 p-1 p-md-2 item2 list-framer-precuentas border ">
                                    <div className='row'>
                                       {!quotes.length
                                          ? <Empty title="Vacío" msg="No hay ordenes pendientes" />
                                          : quotes.map((order, index) => (
                                             <>


                                                <div className='col-lg-4 col-md-6 col-12 mb-3 '>
                                                   <div className="btn-group w-100 h-100" role="group" >
                                                      <input

                                                         className="btn-check-sp input-visually-hidden"

                                                         type={bind == false ? "radio" : "checkbox"}
                                                         autocomplete="off" value={JSON.stringify(order)} name="options-outlined-quote" id={order._id + "quote"}
                                                         onChange={(e) => (selectAction(e, order), handleInputChange(e, index))}
                                                         ref={el => inputRefs.current[index] = el}

                                                      />
                                                      <label
                                                         htmlFor={order._id + "quote"}
                                                         className={`btn btn-choice p-lg-2 p-1  border `}>


                                                         <div key={order.id}>
                                                            <div className="glass-card-preacounts">
                                                               <div className="glass-header">
                                                                  <h2 className="glass-order-id">
                                                                     <i class="uil uil-invoice"></i>
                                                                     Cotizacion: {order.transaction_code}</h2>
                                                               </div>

                                                               <div className="glass-body">

                                                                  <div className="glass-info">
                                                                     <span className="glass-label">Cliente</span>
                                                                     <span className="glass-value">{order.client_name}</span>
                                                                  </div>
                                                                  <div className="glass-info">
                                                                     <span className="glass-label">Telefono</span> <br></br>
                                                                     <span className="glass-value">{order.client_phone}</span>
                                                                  </div>
                                                                  {order.client_email && (<div className="glass-info">
                                                                     <span className="glass-label">Email</span>
                                                                     <span className="glass-value">{order.client_email}</span>
                                                                  </div>)}

                                                                  <div className="glass-info">
                                                                     <span className="glass-label">Ruc</span>
                                                                     <span className="glass-value">{order.client_ruc}</span>
                                                                  </div>
                                                                  <div className="glass-info">
                                                                     <span className="glass-label">Dv</span>
                                                                     <span className="glass-value">{order.client_dv}</span>
                                                                  </div>
                                                                  <div className="glass-info">
                                                                     <span className="glass-label">Sucursal</span>
                                                                     <span className="glass-value">{order.branchoffice.name}</span>
                                                                  </div>

                                                                  <div className="glass-info">
                                                                     <span className="glass-label">Fecha</span>
                                                                     <span className="glass-value">{order.createdAt.slice(0, 10)}</span>
                                                                  </div>



                                                                  {order.note && (
                                                                     <div className='container mb-3'>
                                                                        <div className="p-2 bg-light rounded border">
                                                                           <h5 className="mb-2 text-primary">Nota de la cotizacion</h5>
                                                                           <p>{order.note}</p>
                                                                        </div>
                                                                     </div>
                                                                  )}

                                                                  {order.files && Array.isArray(order.files) && order.files.length > 0 && (
                                                                     <div className='container mb-3'>
                                                                        <div className="p-2 bg-light rounded border">
                                                                           <h5 className="mb-2 text-primary">Archivos adjuntos</h5>
                                                                           <ul className="mb-0 d-flex justify-content-start flex-wrap">
                                                                              {order.files.map((file, idx) => (
                                                                                 <li key={idx} className="d-flex m-1">
                                                                                    <a
                                                                                       href={file.url || file}
                                                                                       target="_blank"
                                                                                       rel="noopener noreferrer"
                                                                                       download
                                                                                       className="btn btn-outline-primary btn-sm d-flex align-items-center"
                                                                                       title={file.url ? file.url.split('/').pop() : (file.name || 'Archivo adjunto')}
                                                                                    >
                                                                                       <i className="uil uil-file-alt" /> {'Archivo adjunto ' + (idx + 1)}
                                                                                    </a>
                                                                                 </li>
                                                                              ))}
                                                                           </ul>
                                                                        </div>
                                                                     </div>
                                                                  )}

                                                                  {order.ecommerce_order == true ? <>

                                                                     <div className="glass-info">
                                                                        <span className="glass-label">Cobro en linea</span>
                                                                        <span className="glass-value">

                                                                           <button className='btn btn-outline-success bg-success-subtle border-0 border-0  btn-sm' onClick={() => { setOrderForSendLink(order); setSendLinkPayment(true) }} >

                                                                              <i class="fa-solid fa-share"></i>  Enviar link

                                                                           </button>
                                                                           <ModalSendLinkPayment sendLinkPayment={sendLinkPayment} setSendLinkPayment={setSendLinkPayment} PreOrderDataCallCenter={orderForSendLink} dataClientSelected={null} dataOrder={null} domain={domain} />
                                                                        </span>
                                                                     </div>



                                                                  </> : <></>}


                                                                  {order.ecommerce_order == true ? <>

                                                                     <div className="glass-info">
                                                                        <span className="glass-label">Cobro en linea</span>
                                                                        <span className="glass-value">

                                                                           <button className='btn btn-outline-success bg-success-subtle border-0 border-0  btn-sm' onClick={() => { setOrderForSendLink(order); setSendLinkPayment(true) }} >

                                                                              <i class="fa-solid fa-share"></i>  Compartir cotizacion

                                                                           </button>
                                                                        </span>
                                                                     </div>



                                                                  </> : <></>}



                                                                  {/*} <div style={{ marginTop: '0.5rem' }}>
                                                                     <span className="glass-badge">{(order.groups.length + order.combos.length)} productos</span>
                                                                  </div>*/}

                                                                  <div className='d-flex justify-content-between mt-2 border-top align-items-center'>

                                                                     <div className="glass-actions ">

                                                                        {/*   <PDFDownloadLink className='m-0 p-0' document={
                                                                           <InvoicePDF
                                                                              data={{
                                                                                 emisor: order.branchoffice.fiscal_name,
                                                                                 emisorRuc: order.branchoffice.ruc,
                                                                                 emisorDv: order.branchoffice.dv,
                                                                                 emisorDireccion: branchOfficeData.direction,
                                                                                 clienteNombre: order.client_name,
                                                                                 clienteRuc: order.client_ruc,
                                                                                 clienteDv: order.client_dv,
                                                                                 clienteDireccion: order.client_address,
                                                                                 clienteTelefono: order.client_phone,
                                                                                 fechaEmision: order.createdAt ? new Date(order.createdAt).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '',
                                                                                 puntoFacturacion: "",
                                                                                 consultaClaveUrl: "",
                                                                                 cufe: "",
                                                                                 items: order.groups,
                                                                                 itbmsBreakdown: order.taxes,
                                                                                 metodoPago: "",
                                                                                 formaPagoMonto: "",
                                                                                 totalPagado: order.total,
                                                                                 tips: order.tips,
                                                                                 subtotal: order.subtotal,
                                                                                 discount: order.discount,
                                                                                 tax: order.tax,
                                                                                 total: order.total,
                                                                                 typeDocument: "quote",
                                                                                 logo: logo,
                                                                                 aditional_info: order.aditional_info ? order.aditional_info : ""


                                                                              }} />
                                                                        } >
                                                                           <button className='btn btn-outline-secondary border-0 border-0  btn-sm border-end' >
                                                                              <i class="uil uil-file-download-alt "></i> Cotizacion lkj </button>
                                                                        </PDFDownloadLink> */}

                                                                     </div>

                                                                     <button className='btn btn-outline-danger border-0 mt-2 btn-sm'
                                                                        data-order={order.code}
                                                                        onClick={async (e) => getTemporalOrderById(order, true)}>
                                                                        <i className="uil uil-trash-alt"> </i>
                                                                     </button>


                                                                  </div>

                                                               </div>
                                                            </div>
                                                         </div >
                                                      </label>
                                                   </div>
                                                </div>
                                             </>
                                          ))
                                       }
                                    </div>

                                 </div>

                                 <div className='d-block mt-lg-1 mt-0 '>
                                    <div className='d-flex justify-content-between justify-content-lg-endn  mx-2 p-2'>

                                       <button className='btn bg-danger-subtle text-danger  border-0 fw-bold '
                                          onClick={() => (setShowModalNew(false), cleanStates())}><i class="uil uil-times-circle"></i> Cancelar </button>

                                       <button className='btn bg-success-subtle text-success fw-bold border-0 ms-1 '
                                          onClick={() => (questionConfirmation())}><i class="uil uil-store"></i>  Enviar al carrito </button>

                                    </div>
                                 </div>
                              </Tab.Pane>
                           </Tab.Content>
                        </Col>
                     </Row>
                     <Tab.Content></Tab.Content>
                  </Tab.Container>





               </div>
            </div >

         )
         }


         {/* MODAL DETALLES DE COTIZACIÓN */}
         <ModalQuoteDetails
            show={showQuoteDetails}
            onClose={() => setShowQuoteDetails(false)}
            quote={selectedQuote}
            branchOfficeData={branchOfficeData}
            logo={logo}
            onShare={() => {
               if (selectedQuote) {
                  // Aquí puedes implementar la lógica de compartir (copiar link, abrir modal, etc)
                  console.log(selectedQuote);
                  navigator.clipboard.writeText(`https://${domainBusiness}.ecommerce.smartpay.ai/order/quote/${selectedQuote.code}`);
                  Swal.fire('¡Enlace copiado!', 'El enlace de la cotización ha sido copiado al portapapeles.', 'success');
               }
            }}
         />



      </>
   )
}

export default ModalPendingOrders
